import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import { SiMeta } from "react-icons/si";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { ROTA_ANUNCIOS, dataHoraBR } from "../api";
import { marcarAvisosMetaLidos } from "./avisosMeta";
import { useAvisosMeta } from "./useAvisosMeta";

const NIVEIS = {
  sucesso: [CheckCircle2, "text-emerald-500"],
  erro: [XCircle, "text-red-500"],
  alerta: [AlertTriangle, "text-amber-500"],
  info: [Info, "text-sky-500"],
};

function Aviso({ aviso, onAbrir }) {
  const [Icone, cor] = NIVEIS[aviso.nivel] || NIVEIS.info;
  return (
    <li>
      <button type="button" onClick={onAbrir} data-e2e="aviso-meta"
        className={`w-full text-left flex items-start gap-2 px-4 py-2.5 hover:bg-muted/50 ${aviso.lido_em ? "opacity-60" : ""}`}>
        <Icone className={`w-4 h-4 mt-0.5 shrink-0 ${cor}`} />
        <span className="flex-1 min-w-0">
          <span className="flex items-center justify-between gap-2">
            <span className="text-sm font-medium truncate">{aviso.titulo}</span>
            <span className="text-[11px] tabular-nums text-muted-foreground shrink-0">{dataHoraBR(aviso.criado_em)}</span>
          </span>
          {aviso.texto && <span className="block text-xs text-muted-foreground line-clamp-3">{aviso.texto}</span>}
        </span>
      </button>
    </li>
  );
}

/**
 * Seção "Anúncios Meta" do sino do cabeçalho. Não renderiza nada sem aviso.
 * `aoFechar` fecha o menu do sino quando a loja abre um aviso.
 */
export default function ListaAvisosMeta({ aoFechar }) {
  const navigate = useNavigate();
  const { avisos, naoLidos } = useAvisosMeta();
  if (avisos.length === 0) return null;

  const abrir = () => { aoFechar?.(); navigate(ROTA_ANUNCIOS); };
  const marcar = async () => {
    try { await marcarAvisosMetaLidos(); } catch { toast.error("Não foi possível marcar os avisos como lidos"); }
  };

  return (
    <div className="border-b" data-e2e="avisos-meta">
      <div className="px-4 py-2 bg-sky-500/10 flex items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 text-xs font-semibold text-sky-600 dark:text-sky-400">
          <SiMeta className="w-3.5 h-3.5" /> Anúncios Meta{naoLidos > 0 ? ` · ${naoLidos} ${naoLidos === 1 ? "novo" : "novos"}` : ""}
        </p>
        {naoLidos > 0 && (
          <button type="button" onClick={marcar} data-e2e="avisos-meta-lidos"
            className="text-[11px] font-medium text-sky-600 dark:text-sky-400 hover:underline">Marcar como lidos</button>
        )}
      </div>
      <ul className="max-h-72 overflow-y-auto divide-y divide-border/60">
        {avisos.map((a) => <Aviso key={a.id} aviso={a} onAbrir={abrir} />)}
      </ul>
    </div>
  );
}
